import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../Component/Header";
const MandatoryPublicDisclosure = () => {
  useEffect(() => {
    document.title =
      "Mandatory Public Disclosure -  The Air Force School Subroto Park";
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li> Academics</li>
          <li> Mandatory Public Disclosure</li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1> Mandatory Public Disclosure</h1>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6">
              <div className="linktab">
                {" "}
                <Link
                  to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/cbsedisclosure.pdf"
                  target="_blank"
                >
                  APPENDIX -IX : MANDATORY PUBLIC DISCLOSURE (SARAS 4.0){" "}
                </Link>{" "}
              </div>
            </div>
            <br />
            <h6>A. GENERAL INFORMATION</h6>
            <div className="col-lg-12">
              <div className="table-responsive maintable">
                <table className="table">
                  <thead>
                    <tr>
                      <th> SL NO </th>
                      <th> INFORMATION </th>
                      <th> DETAILS </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      {" "}
                      <td> 1 </td> <td> NAME OF THE SCHOOL </td>{" "}
                      <td> THE AIR FORCE SCHOOL </td>{" "}
                    </tr>
                    <tr>
                      {" "}
                      <td> 2 </td> <td> AFFILIATION NO. (IF APPLICABLE) </td>{" "}
                      <td> 2780007 </td>{" "}
                    </tr>
                    <tr>
                      {" "}
                      <td> 3 </td> <td> SCHOOL CODE (IF APPLICABLE) </td>{" "}
                      <td> 27130 </td>{" "}
                    </tr>
                    <tr>
                      {" "}
                      <td> 4 </td> <td> COMPLETE ADDRESS WITH PIN CODE </td>{" "}
                      <td>
                        {" "}
                        THE AIR FORCE SCHOOL SUBROTO PARK NEW DELHI-110010{" "}
                      </td>{" "}
                    </tr>
                    <tr>
                      {" "}
                      <td> 5 </td> <td> PRINCIPAL NAME & QUALIFICATION </td>{" "}
                      <td> Ms. LOMINA RAJIV M.Com., B.Ed. </td>{" "}
                    </tr>
                    <tr>
                      {" "}
                      <td> 6 </td> <td> SCHOOL EMAIL ID </td>{" "}
                      <td> tafsdelhi@gmail.com </td>{" "}
                    </tr>
                    <tr>
                      {" "}
                      <td> 7 </td> <td> CONTACT DETAILS (LANDLINE/MOBILE) </td>{" "}
                      <td>
                        {" "}
                        25693063 (Senior Wing)
                        <br /> 25693627 (Junior Wing){" "}
                      </td>{" "}
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <h6> B. DOCUMENTS AND INFORMATION </h6>

            <div className="col-lg-12">
              <div className="table-responsive maintable">
                <table className="table">
                  <thead>
                    <tr>
                      <th> SL NO </th>
                      <th> INFORMATION </th>
                      <th> DETAILS </th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      {" "}
                      <td> 1 </td>{" "}
                      <td>
                        {" "}
                        COPIES OF AFFILIATION/UPGRADATION LETTER AND RECENT
                        EXTENSION OF AFFILIATION, IF ANY{" "}
                      </td>{" "}
                      <td>
                        {" "}
                        <Link
                          target="_blank"
                          to="https://drive.google.com/file/d/1it9GmkIBW4RgfuvozKNjmUjXiZgCEeK6/view?usp=drive_link"
                        >
                          <strong>CLICK HERE</strong>
                        </Link>{" "}
                      </td>{" "}
                    </tr>
                    <tr>
                      {" "}
                      <td> 2 </td>{" "}
                      <td>
                        {" "}
                        COPIES OF SOCIEITES/TRUST/COMPANY REGISTRATION/ RENEWAL
                        CERTIFICATE, AS APPLICABLE{" "}
                      </td>{" "}
                      <td>
                        {" "}
                        <Link
                          target="_blank"
                          to="https://drive.google.com/file/d/1HK8W_ZTr3WH13loKV0WaQoz0SlY_TgWk/view?usp=drive_link"
                        >
                          <strong>CLICK HERE</strong>
                        </Link>{" "}
                      </td>{" "}
                    </tr>
                    <tr>
                      {" "}
                      <td> 3 </td>{" "}
                      <td>
                        {" "}
                        COPY OF NO OBJECTION CERTIFICATE (NOC) ISSUED, IF
                        APPLICABLE, BY THE STATE GOVT/UT{" "}
                      </td>{" "}
                      <td>
                        {" "}
                        Not required as the school is already affiliated vide
                        Affiliation No. 2730001{" "}
                      </td>{" "}
                    </tr>
                    <tr>
                      {" "}
                      <td> 4 </td>{" "}
                      <td>
                        {" "}
                        COPIES OF RECOGNITION CERTIFICATE UNDER RTE ACT, 2009
                        AND IT’S RENEWAL IF APPLCABLE{" "}
                      </td>{" "}
                      <td>
                        {" "}
                        <Link
                          target="_blank"
                          to="https://drive.google.com/file/d/12A9xMNGr1nt9lStuwdGXprqVmyrd20gW/view?usp=drive_link"
                        >
                          <strong>CLICK HERE</strong>
                        </Link>{" "}
                      </td>{" "}
                    </tr>
                    <tr>
                      {" "}
                      <td> 5 </td>{" "}
                      <td>
                        {" "}
                        COPY OF VALID BUILDING SAFETY CERTIFICATE AS PER THE
                        NATIONAL BUILDING CODE{" "}
                      </td>{" "}
                      <td>
                        {" "}
                        <Link
                          target="_blank"
                          to="https://drive.google.com/file/d/1q7WkZE9v9-InSMRihZ7-smiCG1d1sSc5/view"
                        >
                          <strong>CLICK HERE</strong>
                        </Link>{" "}
                      </td>{" "}
                    </tr>
                    <tr>
                      {" "}
                      <td> 6 </td>{" "}
                      <td>
                        {" "}
                        COPY OF VALID FIRE SAFETY CERTIFICATE ISSUED BY THE
                        COMPETENT AUTHORITY{" "}
                      </td>{" "}
                      <td>
                        {" "}
                        <Link
                          target="_blank"
                          to="https://drive.google.com/file/d/1Za5degC83OrV3y0CN1ayO9EEkOJGc15s/view?usp=drive_link"
                        >
                          <strong>CLICK HERE</strong>
                        </Link>{" "}
                      </td>{" "}
                    </tr>
                    <tr>
                      {" "}
                      <td> 7 </td>{" "}
                      <td>
                        {" "}
                        COPY OF THE DEO CERTIFICATE SUBMITTED BY THE SCHOOL FOR
                        AFFLIATION/ UPGRADATION/ EXTENSION OF AFFILIATION SELF
                        CERTIFICATION BY SCHOOL{" "}
                      </td>{" "}
                      <td>
                        {" "}
                        <strong>
                          <Link
                            target="_blank"
                            to="https://drive.google.com/file/d/15LOFCHHuwwhQ2g9xTuWdiPwLiodhDhvW/view?usp=drive_link"
                          >
                            {" "}
                            CLICK HERE{" "}
                          </Link>
                        </strong>{" "}
                      </td>{" "}
                    </tr>
                    <tr>
                      {" "}
                      <td> 8 </td>{" "}
                      <td>
                        {" "}
                        COPIES OF VALID WATER, HEALTH AND SANITATION
                        CERTIFICATES{" "}
                      </td>{" "}
                      <td>
                        {" "}
                        <Link
                          target="_blank"
                          to="https://drive.google.com/file/d/1dNRULQimaoGG_YUSw5SuEBRwzbuH6nkD/view?usp=drive_link"
                        >
                          <strong>CLICK HERE</strong>
                        </Link>{" "}
                      </td>{" "}
                    </tr>{" "}
                  </tbody>
                </table>
              </div>
            </div>
            <h6> C. RESULT AND ACADEMICS </h6>
            <div className="col-lg-12">
              <div className="table-responsive maintable">
                <table className="table">
                  <thead>
                    <tr>
                      <th> SL NO </th>
                      <th> INFORMATION </th>
                      <th> DETAILS </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      {" "}
                      <td> 1 </td> <td> FEE STRUCTURE OF THE SCHOOL </td>{" "}
                      <td>
                        {" "}
                        <Link
                          target="_blank"
                          to="https://drive.google.com/file/d/1Ro3Zm-uZz5Q49xPpkmJrnTtOcycBAO08/view?usp=drive_link"
                        >
                          <strong>CLICK HERE</strong>{" "}
                        </Link>{" "}
                      </td>{" "}
                    </tr>
                    <tr>
                      {" "}
                      <td> 2 </td> <td> ANNUAL ACADEMIC CALENDAR </td>{" "}
                      <td>
                        {" "}
                        <Link
                          target="_blank"
                          to="https://drive.google.com/file/d/1aare3HB-y_tiUX2vzRvdMO1Jy1xK3nho/view?usp=drive_link"
                        >
                          {" "}
                          <strong>CLICK HERE</strong>{" "}
                        </Link>{" "}
                      </td>{" "}
                    </tr>
                    <tr>
                      {" "}
                      <td> 3 </td>{" "}
                      <td> LIST OF SCHOOL MANAGEMENT COMMITTEE (SMC) </td>{" "}
                      <td>
                        {" "}
                        <Link
                          target="_blank"
                          to="https://drive.google.com/file/d/1D4UYoDdlOWzGw0g7J6pOVpPCW25qlTml/view"
                        >
                          <strong>CLICK HERE</strong>{" "}
                        </Link>{" "}
                      </td>{" "}
                    </tr>
                    <tr>
                      {" "}
                      <td> 4 </td>{" "}
                      <td>
                        {" "}
                        LIST OF PARENTS TEACHERS ASSOCIATION (PTA) MEMBERS{" "}
                      </td>{" "}
                      <td>
                        {" "}
                        <Link
                          target="_blank"
                          to="https://drive.google.com/file/d/1j-475UjDYJ8q7pnjsZiMkNNLO9e31Xu6/view"
                        >
                          <strong>CLICK HERE</strong>{" "}
                        </Link>{" "}
                      </td>{" "}
                    </tr>
                    <tr>
                      {" "}
                      <td> 5 </td>{" "}
                      <td>
                        {" "}
                        LAST THREE-YEAR RESULT OF THE BOARD EXAMINATION AS PER
                        APPLICABILITY{" "}
                      </td>{" "}
                      <td>
                        {" "}
                        <Link
                          target="_blank"
                          to="https://drive.google.com/file/d/1AbT4-fiWA_YPqTzH-lnUaVNIel0iBiQq/view?usp=drive_link"
                        >
                          <strong>CLICK HERE</strong>{" "}
                        </Link>{" "}
                      </td>{" "}
                    </tr>{" "}
                  </tbody>
                </table>
              </div>
            </div>

            <h6>D. STAFF (TEACHING)</h6>

            <div className="col-lg-12">
              <div className="table-responsive maintable">
                <table className="table">
                  <thead>
                    <tr>
                      <th> SL NO </th>
                      <th> INFORMATION </th>
                      <th> DETAILS </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      {" "}
                      <td> 1 </td> <td> PRINCIPAL </td> <td> 01 </td>{" "}
                    </tr>
                    <tr>
                      {" "}
                      <td> 2 </td> <td> TOTAL NO. OF TEACHERS </td>{" "}
                      <td> 101 </td>{" "}
                    </tr>
                    <tr>
                      {" "}
                      <td> </td> <td> PGT </td> <td> 19 </td>{" "}
                    </tr>
                    <tr>
                      {" "}
                      <td> </td> <td> TGT </td> <td> 39 </td>{" "}
                    </tr>
                    <tr>
                      {" "}
                      <td> </td> <td> PRT </td>{" "}
                      <td> 34 + (01 HEADMISTRESS) </td>{" "}
                    </tr>
                    <tr>
                      {" "}
                      <td> 3 </td> <td> TEACHERS SECTION RATIO </td>{" "}
                      <td>
                        {" "}
                        PGT – 1.85 per section
                        <br /> TGT – 1.65 per section <br /> PRT – 1.25 per
                        section{" "}
                      </td>{" "}
                    </tr>
                    <tr>
                      {" "}
                      <td> 4 </td> <td> DETAILS OF SPECIAL EDUCATOR </td>{" "}
                      <td>
                        {" "}
                        MS ANU MOHAN SHARMA <br /> M Ed (Spl Education) BMR{" "}
                      </td>{" "}
                    </tr>
                    <tr>
                      {" "}
                      <td> 5 </td>{" "}
                      <td> DETAILS OF COUNSELLOR AND WELLNESS TEACHER </td>{" "}
                      <td>
                        {" "}
                        MS YUKTI MADAN B Sc (H), M Sc(HDCS), PGDCFT{" "}
                      </td>{" "}
                    </tr>
                    <tr>
                      {" "}
                      <td> 6 </td> <td> STAFF DETAILS</td>{" "}
                      <td>
                        {" "}
                        <Link
                          to="https://drive.google.com/file/d/1rFyxYh-83VX1MAV1kFDv-6rScZGMyGK9/view"
                          target="_blank"
                        >
                          Click Here
                        </Link>{" "}
                      </td>{" "}
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <h6>E. SCHOOL INFRASTRUCTURE</h6>
            <div className="col-lg-12">
              <div className="table-responsive maintable">
                <table className="table">
                  <thead>
                    <tr>
                      <th> SL NO </th>
                      <th> INFORMATION </th>
                      <th colspan="3"> DETAILS </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      {" "}
                      <td> 1. </td>{" "}
                      <td> TOTAL CAMPUS AREA OF THE SCHOOL (IN SQUARE MTR) </td>{" "}
                      <td colspan="3"> 60,696 SQM </td>{" "}
                    </tr>
                    <tr>
                      {" "}
                      <td> 2. </td>{" "}
                      <td>
                        {" "}
                        NO. AND SIZE OF THE CLASS ROOMS (IN SQ FT / MTR){" "}
                      </td>{" "}
                      <td colspan="3">
                        {" "}
                        Total Classrooms: 65 , 522 Sqft / 48.49 Sq Meters each
                        classroom{" "}
                      </td>{" "}
                    </tr>
                    <tr>
                      {" "}
                      <td rowspan="9"> 3. </td>{" "}
                      <td rowspan="9">
                        {" "}
                        NO. AND SIZE OF LABORATORIES INCLUDING COMPUTER LABS (IN
                        SQ MTR){" "}
                      </td>{" "}
                      <td colspan="3"> No of Labs: 12 </td>{" "}
                    </tr>
                    <tr>
                      {" "}
                      <td> Lab </td> <td> No of Labs </td>{" "}
                      <td>
                        {" "}
                        Area
                        <br /> (in SqM){" "}
                      </td>{" "}
                    </tr>
                    <tr>
                      {" "}
                      <td> Physics </td> <td> 02 </td> <td> 178 </td>{" "}
                    </tr>
                    <tr>
                      {" "}
                      <td> Chemistry </td> <td> 02 </td> <td> 166 </td>{" "}
                    </tr>
                    <tr>
                      {" "}
                      <td> Biology </td> <td> 02 </td> <td> 164 </td>{" "}
                    </tr>
                    <tr>
                      {" "}
                      <td> Computer </td> <td> 03 </td> <td> 258 </td>{" "}
                    </tr>
                    <tr>
                      {" "}
                      <td> Maths </td> <td> 01 </td> <td> 53 </td>{" "}
                    </tr>
                    <tr>
                      {" "}
                      <td> Geography </td> <td> 01 </td> <td> 43 </td>{" "}
                    </tr>
                    <tr>
                      {" "}
                      <td> Home Sci </td> <td> 01 </td> <td> 90 </td>{" "}
                    </tr>
                    <tr>
                      {" "}
                      <td> 4. </td> <td> INTERNET FACILITY (Y/N) </td>{" "}
                      <td colspan="3"> YES </td>{" "}
                    </tr>
                    <tr>
                      {" "}
                      <td> 5. </td> <td> NO OF GIRLS TOILETS </td>{" "}
                      <td colspan="3"> 30 </td>{" "}
                    </tr>
                    <tr>
                      {" "}
                      <td> 6. </td> <td> NO OF BOYS TOILETS </td>{" "}
                      <td colspan="3"> 27 </td>{" "}
                    </tr>
                    <tr>
                      {" "}
                      <td> 7.</td>{" "}
                      <td>
                        {" "}
                        LINK OF YOUTUBE VIDEO OF THE INSPECTION OF SCHOOL
                        COVERING THE INFRASTRUCTURE OF THE SCHOOL{" "}
                      </td>{" "}
                      <td colspan="3">
                        {" "}
                        <strong>
                          <Link
                            target="_blank"
                            to="https://youtu.be/jkS7Ryti52A"
                          >
                            CLICK HERE{" "}
                          </Link>
                        </strong>{" "}
                      </td>{" "}
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="linktab">
                {" "}
                <Link
                  to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Multiple_Committees.pdf"
                  target="_blank"
                >
                  MULTIPLE COMMITTEES - CHILD PROTECTION POLICIES{" "}
                </Link>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MandatoryPublicDisclosure;
